import { transliterate } from 'transliteration';
import { v4 as uuidv4 } from 'uuid';
import { convertJsConceptToGrpcConcept } from 'utils/grpc/jsToGrpc';

interface ConceptNameIdSet {
  name: string;
  id: string;
}

const _generateRandomString = (length: number): string => {
  return uuidv4().replace(/-/g, '').slice(0, length);
};

export const createValidConceptName = (value: string): string =>
  value
    .replace(/[^\s\w./\u0080-\uFFFF-]/g, '') // Allow Unicode characters only
    .slice(0, 128);

export function createValidConceptNameIdSet(value: string): ConceptNameIdSet {
  const name = createValidConceptName(value);

  let id = transliterate(value)
    .replace(/[^\d\sA-Za-z]/g, '-') // Replace any special characters with hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/^-+|-+$/g, '') // Remove leading and trailing hyphens
    .toLowerCase();

  if (id.length === 0 || id.replace(/-/g, '').length === 0) {
    id = _generateRandomString(10);
  } else {
    // Get first 43 characters of the id and append a random string to it
    // This is to ensure that the id is unique and does not exceed the 48 character limit
    // Note: Some characters can be transelitated to exact same alphanumeric string, so we need to add random string
    id = id.slice(0, 43) + _generateRandomString(5);
  }

  return { name, id };
}

const _createConcept = (conceptName: string): CF.API.Concept => {
  const { id, name } = createValidConceptNameIdSet(conceptName);

  return {
    id,
    name,
    value: 1,
  };
};

export const createGrpcConcept = (conceptName: string) => {
  return convertJsConceptToGrpcConcept(_createConcept(conceptName));
};
